'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FitnessTrendsRoute = undefined;

var _path = require('helpers/path');

var _FitnessTrendsOnenter = require('features/FitnessTrends/FitnessTrends.onenter.saga');

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var FitnessTrendsRoute = exports.FitnessTrendsRoute = function FitnessTrendsRoute(store) {
  return {
    path: '/fitness-trends',

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function () {
        callback(null, {
          onEnter: (0, _path.redirectTo)('/fitness-trends/community/2018')
        });
      }, 'FitnessTrends');
    },

    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'community/:year',
          component: require('features/FitnessTrends/Community/FitnessTrendsCommunityContainer').FitnessTrendsCommunityContainer
        }, {
          path: 'members/:memberHash/:year',
          component: require('features/FitnessTrends/Member/FitnessTrendsMemberContainer').FitnessTrendsMemberContainer,
          // Ignoring testing since this is temporary until feature release
          onEnter: /* istanbul ignore next */function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(_FitnessTrendsOnenter.fitnessTrendsOnEnter, store, nextState, replaceState).done.then(cb);
          }
        }]);
      }, 'FitnessTrends');
    }
  };
};